import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum ToastTypes {
  error,
  success
}

export interface ToastData {
  title: string;
  content: string;
  show?: boolean;
  type?: ToastTypes;
  progressWidth?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public data: ToastData | undefined;
  public open = new Subject<ToastData>();

  initiate(data: ToastData) {
    if (data.type == undefined) {
      data.type = ToastTypes.error;
    }
    this.data = { ...data, show: true, progressWidth: '100%' };
    this.open.next(this.data);
  }

  hide() {
    this.data = { ...this.data!, show: false };
    this.open.next(this.data);
  }
}
